import React from 'react';

const SettingsPage = ({
  routines,
  selectedRoutineId,
  setTitle,
  setHour,
  setMinute,
  setTasks,
  childrenDraft,
  onSelectRoutine,
  onAddRoutine,
  onRemoveRoutine,
  onSetTitle,
  onSetHour,
  onSetMinute,
  onSetTasks,
  onAddChild,
  onRemoveChild,
  onUpdateChildName,
  onUpdateChildIcon,
  onCancel,
  onSave,
}) => (
  <div className="settings-overlay" id="settingsOverlay" style={{ display: 'flex' }}>
    <div className="settings-card">
      <h2>⚙️ Indstillinger</h2>
      <div className="settings-grid">
        <div className="field">
          <label htmlFor="setRoutineSelect">Rutine</label>
          <div className="routine-row">
            <select id="setRoutineSelect" value={selectedRoutineId} onChange={(e) => onSelectRoutine(e.target.value)}>
              {routines.map((routine) => (
                <option key={routine.id} value={routine.id}>
                  {routine.title}
                </option>
              ))}
            </select>
            <button className="mini-btn" onClick={onAddRoutine}>
              ➕ Ny
            </button>
            <button className="mini-btn danger" onClick={onRemoveRoutine} disabled={routines.length <= 1}>
              🗑 Fjern
            </button>
          </div>
        </div>

        <div className="field">
          <label htmlFor="setTitle">Rutinenavn / overskrift</label>
          <input id="setTitle" type="text" placeholder="Morgenmission" value={setTitle} onChange={(e) => onSetTitle(e.target.value)} />
        </div>

        <div className="row">
          <div className="field">
            <label htmlFor="setHour">Afgangstid - time</label>
            <input id="setHour" type="number" min="0" max="23" value={setHour} onChange={(e) => onSetHour(e.target.value)} />
          </div>
          <div className="field">
            <label htmlFor="setMinute">Afgangstid - minut</label>
            <input id="setMinute" type="number" min="0" max="59" value={setMinute} onChange={(e) => onSetMinute(e.target.value)} />
          </div>
        </div>
        <div className="field">
          <label htmlFor="setTasks">
            Opgaver
            <span style={{ margin: '6px', color: 'var(--muted)', fontWeight: 'lighter' }}>
              - Format for opgaver: <b>ikon|tekst</b>, adskilt med komma
            </span>
          </label>
          <textarea
            id="setTasks"
            placeholder="👕|Tag tøj på,🥣|Spis morgenmad,🦷|Børst tænder"
            value={setTasks}
            onChange={(e) => onSetTasks(e.target.value)}
          />
          <div className="help">Eksempel: 👕|Tag tøj på,🥣|Spis morgenmad,🦷|Børst tænder,🎒|Pak taske,👟|Tag sko på</div>
        </div>

        <div className="field">
          <div style={{ fontSize: '.88rem', fontWeight: 900, margin: '0 0 6px', color: 'var(--muted)' }}>Børn (ikon + navn)</div>
          <div className="children-settings-list">
            {childrenDraft.map((child, index) => (
              <div className="child-setting-row" key={`${child.name}-${index}`}>
                <input
                  className="icon-input"
                  type="text"
                  maxLength={4}
                  value={child.icon}
                  onChange={(e) => onUpdateChildIcon(index, e.target.value)}
                  placeholder="🙂"
                />
                <input
                  type="text"
                  value={child.name}
                  onChange={(e) => onUpdateChildName(index, e.target.value)}
                  placeholder={`Barn ${index + 1}`}
                />
                <button className="mini-btn danger" onClick={() => onRemoveChild(index)} disabled={childrenDraft.length <= 1}>
                  Fjern
                </button>
              </div>
            ))}
          </div>
          <button className="mini-btn" onClick={onAddChild}>
            ➕ Tilføj barn
          </button>
        </div>
      </div>
      <div className="settings-actions">
        <button className="action-btn secondary" onClick={onCancel}>
          Annuller
        </button>
        <button className="action-btn" onClick={onSave}>
          Gem
        </button>
      </div>
    </div>
  </div>
);

export default SettingsPage;
